import React, { useContext, memo } from "react";
import { Link as RouterLink } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { useGetAdminStatusQuery } from "../../../services/admin/admin";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { AdminPanelSettings as AdminIcon } from "@mui/icons-material";

function AdminNavbar() {
  const { isAuthenticated } = useContext(AuthContext);
  const { data: adminStatus, isLoading: isAdminLoading } =
    useGetAdminStatusQuery(undefined, { skip: !isAuthenticated });
  const isAdmin = adminStatus?.isAdmin;
  
  return (
    <div className="app-admin-header-navbar">
      {isAdminLoading ? (
        <CircularProgress size={24} />
      ) : (
        isAuthenticated &&
        isAdmin && (
          <Button
            variant="contained"
            component={RouterLink}
            to="/admin"
            sx={{
              margin: "0 1rem 0.5rem 0",
              color: "#FFF",
              backgroundColor: "#4CAF50",
            }}
            startIcon={<AdminIcon />}
          >
            Admin Dashboard
          </Button>
        )
      )}
    </div>
  );
}

export default memo(AdminNavbar);
